import Color from 'color'

export const clarearCor = cor => {
    const color = Color(cor)
    return color.lighten(.2).hex()
}